import { useTheme } from "@/contexts/theme-provider";
import fleetOneLogo from "@/assets/fleetone-logo.png";
import fleetOneLogoLight from "@/assets/fleetone-logo-light.png";
import fleetOneIcon from "@/assets/fleetone-icon.png";

interface FleetLogoProps {
  variant?: 'full' | 'icon';
  className?: string;
  alt?: string;
}

export function FleetLogo({ variant = 'full', className = '', alt }: FleetLogoProps) {
  const { theme } = useTheme();
  
  const isDark = theme === 'dark' || 
    (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  
  if (variant === 'icon') {
    return (
      <img 
        src={fleetOneIcon} 
        alt={alt || "FleetONE"} 
        className={className} 
      />
    );
  }
  
  return (
    <img 
      src={isDark ? fleetOneLogo : fleetOneLogoLight}
      alt={alt || "FleetONE - Gestão Inteligente de Frotas"}
      className={className}
    />
  );
}
